<script>
import TablePage from '@/found/components/table_page';
import request from '@/found/utils/request';
import Form from './form';

export default {
  extends: TablePage,
  components: {
    Form,
  },
  data() {
    return {
      // requestType: 'POST',
    };
  },
  mounted() {
    this.getConfigList('main_list');
  },
  methods: {
    modalClick({ val, row }) {
      console.log(val, row);
      const urls = '/tax/v1/terminalCash/api/pay';
      const text = '打款';
      if (val.code === 'add') {
        this.formConfig = {
          ...this.formConfig,
          code: val.code,
          row,
        };
        this.modalConfig.title = '新增';
        this.openFull();
      }
      if (val.code === 'view') {
        this.formConfig = {
          ...this.formConfig,
          code: val.code,
          row,
        };
        this.modalConfig.title = '查看详情';
        this.openFull();
      }
      if (val.code === 'edit') {
        this.formConfig = {
          ...this.formConfig,
          code: val.code,
          row,
        };
        this.modalConfig.title = '编辑';
        this.openFull();
      }
      if (val.code === 'enable' || val.code === 'disable') {
        this.switchEnable(val.code);
      }
    },
    switchEnable(code) {
      if (this.selection.length === 0) {
        return this.$message.error('请选择数据');
      }
      const urls = code === 'enable'
        ? '/tax/v1/cash/setting/taxRateRuleSetting/enable'
        : '/tax/v1/cash/setting/taxRateRuleSetting/disable';
      request.post(urls, this.selection).then((res) => {
        if (res.success) {
          this.$message({
            type: 'success',
            message: res.message,
          });
          this.selection = [];
          this.getList();
        }
      });
    },
  },
};
</script>
